module.exports = __webpack_public_path__ + "static/media/dark-bg.0d4d5e0f.jpg";